import { TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { StorageService } from './storage.service';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export class AppTranslate extends StorageService {
  constructor(translate: TranslateService) {
    super();

    const currentUser = this.getCurrentUser();
    if (currentUser) {
      // the lang to use, if the lang isn't available, it will use the current loader to get them
      translate.use(currentUser.language_id);
    } else {
      // this language will be used as a fallback when a translation isn't found in the current language
      translate.setDefaultLang('es_CL');
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/app.translate.ts